
import React, { useState } from 'react';
import tyreSize from './../images/check-tyre-size.png';

function TyreBookingForm() {
  const [tyreSizes, setTyreSizes] = useState({
    sectionWidth: '',
    aspectRatio: '',
    rimDiameter: '',
  });
  const [option, setOption] = useState('budget');
  const [brand, setBrand] = useState('');
  const [customBrand, setCustomBrand] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // New state for loadin
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const resetForm = () => {
    setTyreSizes({ sectionWidth: '', aspectRatio: '', rimDiameter: '' });
    setOption('budget');
    setBrand('');
    setCustomBrand('');
    setName('');
    setEmail('');
    setPhone('');
    setSubmitted(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true); 

    const formData = {
      name,
      email,
      phone,
      tyreSizes,
      option,
      brand: brand === 'other' ? customBrand : brand,
    };

    fetch('https://l42lq1jrmj.execute-api.eu-west-2.amazonaws.com/dev/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        setLoading(false); // Stop loading
        if (response.ok) {
          setSubmitted(true); // Set as submitted
        } else {
          console.error('Error submitting form');
        }
      })
      .catch((error) => {
        setLoading(false); // Stop loading on error
        console.error('Error:', error);
      });
  };

  const handleOptionChange = (e) => {
    setOption(e.target.value);
    setBrand('');
  };

  return (
    <div className="flex justify-center items-center h-full bg-base-200">
      {!submitted ? (
        <form
          className="card shadow-xl bg-base-100 p-6 w-full max-w-lg m-10"
          onSubmit={handleSubmit}
        >
          <h2 className="card-title text-center mb-4">
            Please Check & Select Your Tyre Size
          </h2>
          <p className="text-center mb-4">
            Check the sidewall of your tyre and confirm your size
          </p>
          <div className="flex justify-center w-full">
            <img
              src={tyreSize}
              alt="Tyre Size Diagram"
              className="mb-4 max-w-xs"
              style={{ height: 'auto' }}
            />
          </div>

          {/* Name Input */}
          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text">Your Name</span>
            </label>
            <input
              type="text"
              placeholder="Enter your name"
              className="input input-bordered w-full"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* Email Input */}
          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text">Your Email</span>
            </label>
            <input
              type="email"
              placeholder="Enter your email"
              className="input input-bordered w-full"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Phone Input */}
          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text">Your Phone Number</span>
            </label>
            <input
              type="number"
              placeholder="Enter your phone number"
              className="input input-bordered w-full"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          {/* Tyre Size Input (Width, Ratio, Diameter on one line) */}
          <div className="form-control mb-4">
            <div className="flex space-x-4">
              <div className="w-1/3">
                <label className="label">
                  <span className="label-text">Width</span>
                </label>
                <input
                  type="text"
                  placeholder="Width"
                  className="input input-bordered w-full"
                  value={tyreSizes.sectionWidth}
                  onChange={(e) =>
                    setTyreSizes({ ...tyreSizes, sectionWidth: e.target.value })
                  }
                  required
                />
              </div>
              <div className="w-1/3">
                <label className="label">
                  <span className="label-text">Profile</span>
                </label>
                <input
                  type="text"
                  placeholder="Ratio"
                  className="input input-bordered w-full"
                  value={tyreSizes.aspectRatio}
                  onChange={(e) =>
                    setTyreSizes({ ...tyreSizes, aspectRatio: e.target.value })
                  }
                  required
                />
              </div>
              <div className="w-1/3">
                <label className="label">
                  <span className="label-text">Rim</span>
                </label>
                <input
                  type="text"
                  placeholder="Rim"
                  className="input input-bordered w-full"
                  value={tyreSizes.rimDiameter}
                  onChange={(e) =>
                    setTyreSizes({ ...tyreSizes, rimDiameter: e.target.value })
                  }
                  required
                />
              </div>
            </div>
          </div>

          {/* Budget or Premium Option */}
          <div className="form-control mb-4">
            <label className="label">
              <span className="label-text">Select Option</span>
            </label>
            <div className="flex space-x-4">
              <label className="cursor-pointer flex items-center space-x-2">
                <input
                  type="radio"
                  value="budget"
                  checked={option === 'budget'}
                  onChange={handleOptionChange}
                  className="radio"
                />
                <span>Budget</span>
              </label>
              <label className="cursor-pointer flex items-center space-x-2">
                <input
                  type="radio"
                  value="premium"
                  checked={option === 'premium'}
                  onChange={handleOptionChange}
                  className="radio"
                />
                <span>Premium</span>
              </label>
            </div>
          </div>

          {/* Conditional Premium Options */}
          {option === 'premium' && (
            <div className="form-control mb-4">
              <label className="label">
                <span className="label-text">Select a Brand</span>
              </label>
              <select
                className="select select-bordered"
                value={brand}
                onChange={(e) => setBrand(e.target.value)}
                required
              >
                <option value="">Select a Brand</option>
                <option value="Michelin">Michelin</option>
                <option value="Nokian Tyres">Nokian Tyres</option>
                <option value="Uniroyal">Uniroyal</option>
                <option value="Pirelli">Pirelli</option>
                <option value="Continental">Continental</option>
                <option value="Hankook">Hankook</option>
                <option value="Yokohama">Yokohama</option>
                <option value="Vredestein">Vredestein</option>
                <option value="Goodyear">Goodyear</option>
                <option value="other">Other</option>
              </select>

              {brand === 'other' && (
                <input
                  type="text"
                  className="input input-bordered mt-2"
                  placeholder="Enter Brand"
                  required
                  onChange={(e) => setCustomBrand(e.target.value)}
                />
              )}
            </div>
          )}

          <div className="form-control mt-6">
            <button
              type="submit"
              className="btn !text-white bg-rescueRed hover:bg-white hover:!text-rescueRed"
              disabled={loading} 
            >
              {loading ? 'Submitting...' : 'Submit'} 
            </button>
          </div>
        </form>
      ) : (
        <div className="card shadow-xl bg-base-100 p-6 w-full max-w-lg m-10">
          <h3 className="text-2xl text-center">Thank you!</h3>
          <p className="text-center mt-2">
            Someone will be in touch to confirm your booking.
          </p>
          <button
            className="btn mt-4 bg-gray-500 hover:bg-gray-700 text-white"
            onClick={resetForm}
          >
            Submit Another Request
          </button>
        </div>
      )}
    </div>
  );
}

export default TyreBookingForm;
